import { Button } from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import { ArrowForwardIcon } from "@chakra-ui/icons";

// The bottom-right "next page in the flow" button shared by About, Rules,
// Strategy, and Practice. `marginTop: "auto"` pushes it to the bottom of
// whatever flex column it's the trailing child of, landing just inside
// that page's own bottom padding (the breathing room above the footer) -
// when content already overflows the viewport this resolves to ~0 extra
// space, so the button just follows the content as before, no JS needed.
const NextPageButton = ({ to, label }) => (
  <NavLink
    to={to}
    style={{
      textDecoration: "none",
      alignSelf: "flex-end",
      marginTop: "auto",
    }}
  >
    <Button bg="bg.100">
      {label} &nbsp;
      <ArrowForwardIcon />
    </Button>
  </NavLink>
);
export default NextPageButton;
